import React from "react";
// import { useSelector } from "react-redux";
// import { selectPreReqTypeOfLoad } from "../../redux/preReq/preReq.selectors";
import CarSelection from "../carSelection/carSelection.component";
import SubmitReqPreForm from "../submitReqPreForm/SubmitReqPreForm.component";
import SubmitReqPreSubBtns from "../submitReqPreSubBtns/SubmitReqPreSubBtns.component";
import VehicleType from "../vehicleType/vehicleType.component";

import { SubmitReqPreStyled } from "./submitReqPre.styles";

const SubmitReqPre = () => {
  // const typeOfLoad = useSelector(selectPreReqTypeOfLoad);

  return (
    <SubmitReqPreStyled>
      {/* <div className="slider-car">
        <CarSelection second />
      </div> */}
      <div className="mt-1">
        <VehicleType />
      </div>

      <div>
        <SubmitReqPreForm />
      </div>
      <SubmitReqPreSubBtns className="mt-3" />
    </SubmitReqPreStyled>
  );
};

export default SubmitReqPre;
